
import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { useValidation } from '../../../../../../../../../hooks/use-validation';
import { FormGroup, TextInput, NumericInput, RadioButton, RadioTextInput, CurrencyInput, InputGroup, DateInput, FormTitleTooltip, TextArea } from '../../../../../../../../../components/form/form';
import { securityInfoObj3, securityInfoValidator3 } from '../../../../../../../../../form-control/listing-form/security-info-control';
import { getTransferOfSecurityRestrictions } from '../../../../../../../../../helpr/listingFormData';


import styles from './security-information.module.scss'

const SecurityInformation3 = ({listingInfo, saveListingInfo, nextStep}) => {
  const listingFormState = useValidation(securityInfoValidator3, securityInfoObj3(listingInfo), {borderColor: 'red'});
  const { getTextAreaProps, getRadioButtonProps, validate } = listingFormState;
  const ownershipType = [
    { name: 'Filipino', value: 'FIL' },
    { name: 'Foreign',  value: 'FOREIGN' },
    { name: 'Not Applicable',  value: 'N/A' },
  ]

  const nextHandler = (step) => {
    console.log(listingInfo);
    const { isFormValid, formState } = validate();
    saveListingInfo({
      ...formState,
      ownershipLimit: {
        type: formState.ownershipType,
        percentage: formState.ownershipPercentage
      },
      tax: {
        applicable: (formState.taxApplicable === 'true'),
        percentage: formState.taxPercentage
      }
    });
    if( step ){ console.log(); nextStep(step) }
    else if ( isFormValid ){ nextStep(step) }
    else { /*Invalid Form State*/ }
  }

  return (
    <div className={styles['security-information-component']}>
      <Row>
        <Col>
          <FormGroup header="Description of Pre-termination Provisions, if any">
            <Row>
              <Col md="6">
                <TextArea inputProps={getTextAreaProps('preterminationProvisionDescription')} maxLength="250"/>
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup header="Restrictions on transfer of security:*">
            <RadioButton
              inputProps={getRadioButtonProps('transferOfSecurityRestrictions')}
              data={getTransferOfSecurityRestrictions()}
              othersOption
              textFieldLarge={true}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup header="OWNERSHIP LIMIT:*">
            <RadioTextInput inputProps={getRadioButtonProps('ownershipType')} data={ownershipType} noOptionIndexes={[2]}>
              <NumericInput inputProps={getRadioButtonProps('ownershipPercentage')} placeholder="%" decimalLimit={4} numberLimit={100}/>
            </RadioTextInput>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup header="TAX APPLICABLE:*">
            <RadioTextInput inputProps={getRadioButtonProps('taxApplicable')} data={[{name: 'No', value: 'false'}, {name: 'Yes', value: 'true'}]} noOptionIndexes={[0]}>
              <NumericInput inputProps={getRadioButtonProps('taxPercentage')} placeholder="%" decimalLimit={4} numberLimit={100}/>
            </RadioTextInput>
          </FormGroup>
        </Col>
      </Row>
      <Row className={styles['btn-actions']}>
        <Button onClick={()=>nextHandler(true)} className="btn-secondary">BACK</Button>
        <Button onClick={()=>nextHandler()}>NEXT</Button>
      </Row>
    </div>
  )
}

export default SecurityInformation3;

